import ProfileDropdown from './ProfileDropdown'
import SupportWidget from './SupportWidget'
import AppLanguageSwitcher from './AppLanguageSwitcher'
import WorkspaceSwitcher from './WorkspaceSwitcher'

interface HeaderProps {
  firstName?: string
  onLogout?: () => void
  pageTitle?: string
  currentWorkspaceId?: number
  onWorkspaceChange?: (workspaceId: number) => void
}

export default function Header({ firstName = 'Profil', onLogout, pageTitle, currentWorkspaceId, onWorkspaceChange }: HeaderProps) {
  return (
    <div className="flex items-center justify-between w-full">
      {/* Left: Page Title Badge + Workspace Switcher */}
      <div className="flex items-center gap-3">
        {pageTitle && (
          <div className="inline-flex items-center px-4 py-2 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
            <span className="text-sm font-bold uppercase tracking-wider text-emerald-400">
              {pageTitle}
            </span>
          </div>
        )}
        
        <WorkspaceSwitcher 
          currentWorkspaceId={currentWorkspaceId}
          onWorkspaceChange={onWorkspaceChange}
        />
      </div>
      
      {/* Support Widget (center) */}
      <SupportWidget />
      
      {/* Language Switcher + Profile Dropdown (right) */}
      <div className="flex items-center gap-3">
        <AppLanguageSwitcher />
        <ProfileDropdown 
          firstName={firstName} 
          onLogout={onLogout || (() => {})} 
        />
      </div>
    </div>
  )
}
